import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useGetIndividualFeeQuery } from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import UserRole from '../../../shared/AuthRoles';
import FeeForm from '../../components/Fees/FeeForm';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const EditFeePage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const [url, setUrl] = useState('');
    const { data: getIndividualFee, isFetching } =
        useGetIndividualFeeQuery(url);
    const urlRef = window.location.href.split('/')[4];
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'feesPage',
                },
            });
        }
    }, [loggedInUser.role]);

    useEffect(() => {
        if (urlRef !== undefined) {
            if (
                loggedInUser?.role === 'owner_admin' ||
                loggedInUser?.role === 'owner_company' ||
                loggedInUser?.role === 'owner_user'
            ) {
                setUrl(`/owners/${loggedInUser?.company}/fees/${urlRef}`);
            } else if (
                loggedInUser?.role === 'guest_admin' ||
                loggedInUser?.role === 'guest_company'
            ) {
                setUrl(`/guests/${loggedInUser?.company}/users/${urlRef}`);
            } else {
                setUrl(`/7-day/users/${urlRef}`);
            }
        }
    }, [loggedInUser?.company]);

    const handleBackButton = () => {
        navigate(`/fees`);
    };

    return (
        <>
            {isFetching === true ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile ? '80vh' : '95%',
                        justifyContent: 'left',
                        alignItems: 'center',
                    }}
                >
                    <FeeForm fee={getIndividualFee} />
                    <CustomButton
                        onClick={handleBackButton}
                        color='green'
                        sx={{
                            marginLeft: '-8px',
                            display: isMobile || isIpad ? 'none' : 'flex', // Hide on mobile
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />{' '}
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to list
                        </Typography>
                    </CustomButton>
                </Grid>
            )}
        </>
    );
};

export default EditFeePage;
